import useSWR from "swr";
import VirtualTable from "../../custom/VirtualTable";
import apiClient from "../../../apiClient";
import ActionIcon from "../../custom/ActionIcon";
import { getTsDate } from "../../../utils";
import moment from "moment";
import styled from "styled-components";

const fetcher = async (endpoint: string) => {
    try {
        const res = await apiClient.get(endpoint);
        return res.data;
    } catch (err) {
        return [];
    }
}

export default function RecurringTrainingRecords ({
    tableRef,
    handleExportData
}: {
    tableRef: React.MutableRefObject<undefined>;
    handleExportData: (name: string) => void;
}) {

    const {
        data
    } = useSWR(`/getRecurringTraining`, fetcher, {
        fallbackData: []
    });

    return (
        <div>
            <FlexContainer>
                <ActionIcon 
                    type='csv'
                    onClick={() => handleExportData(`Recurring Training ${moment().format('YYYY-MM-DD')}.csv`)}
                />
            </FlexContainer>
            <VirtualTable 
                data={data}
                mapping={[{
                    name: 'Module',
                    value: 's_module_name'
                }, {
                    name: 'Unit',
                    value: 's_unit'
                }, {
                    name: 'Type: PPT/QUIZ',
                    value: 's_access_type',
                    customWidth: 150
                }, {
                    name: 'User Email',
                    value: 's_user_id'
                }, {
                    name: 'First Name',
                    value: 's_first_name'
                }, {
                    name: 'Last Name',
                    value: 's_last_name'
                }, {
                    name: 'Next Training Date',
                    value: 'd_next_training_date',
                    date: true,
                    utc: true
                }, {
                    name: 'Last Completed',
                    value: 't_last_completed',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Training Freq. (months)',
                    value: 'i_training_frequency_months',
                    number: true,
                    customWidth: 150
                }]}
                reactTableRef={tableRef}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;  